'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);


var PanelHeader = function PanelHeader(_ref) {
  var title = _ref.title,
      onClose = _ref.onClose,
      goBack = _ref.goBack,
      stepId = _ref.stepId,
      headerRef = _ref.headerRef;
  return _react2.default.createElement(
    'div',
    { className: cx('xsui-side-panel__header'), ref: headerRef },
    _react2.default.createElement(
      'div',
      null,
      stepId && _react2.default.createElement(
        'div',
        {
          className: cx('xsui-side-panel__icon', 'xsui-side-panel__icon--back'),
          onClick: goBack },
        _react2.default.createElement(_icon2.default, { name: 'chevron-reverse', color: '#bdc9d2', size: 32 })
      )
    ),
    title && _react2.default.createElement(
      'p',
      { className: cx('xsui-side-panel__title') },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: cx('xsui-side-panel__icon', 'xsui-side-panel__icon--close'), onClick: onClose },
      _react2.default.createElement(_icon2.default, { name: 'close', color: '#bdc9d2', size: 32 })
    )
  );
};

PanelHeader.propTypes = {
  title: function title() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
  },
  onClose: _propTypes2.default.func.isRequired,
  goBack: _propTypes2.default.func.isRequired,
  stepId: _propTypes2.default.string,
  headerRef: _propTypes2.default.shape({
    current: function current() {
      return (typeof _react.bpfrpt_proptype_ElementRef === 'function' ? _react.bpfrpt_proptype_ElementRef : _propTypes2.default.shape(_react.bpfrpt_proptype_ElementRef)).apply(this, arguments);
    }
  }).isRequired
};
exports.default = PanelHeader;